import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LoginService } from 'lps-navigation';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../../enviroment/environment.service';

@Injectable({
  providedIn: 'root'
})
export class BrokerProfileGuard implements CanActivate {
  constructor(
    public envService: EnvironmentService,
    public loginService: LoginService,
  ) {
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (this.envService.getEnvVar('feature_new_broker_profile')) {
        if (window.location.origin === this.envService.getEnvVar('base_url_crm') &&
            this.loginService.getAuthInformation().isUserLoggedIn() &&
            this.loginService.getAuthInformation().isAgent()) {
          return true;
        } else if (window.location.origin === this.envService.getEnvVar('portal_url')) {
          return true;
        } else if (window.location.origin === this.envService.getEnvVar('base_url_crm') && 
        !this.loginService.getAuthInformation().isUserLoggedIn()) {
          window.location.href = `${this.envService.getBasePortalUrl()}`;
        }
      }
  }

}
